import type { MarketConfig } from '../../types';

export const academyInCisoConfig = {
  slug: 'aca-in-ciso',
  label: 'Academy India',
  country: 'IN',
  language: 'en',
  siteSection: 'ACA_IN',
  cms: 'AzureSWA',
  title: 'Chief Information Security Officer Career Path | TÜV SÜD Academy India',
  description:
    'Lead generation landing page for the Chief Information Security Officer (CISO) career path by TÜV SÜD Academy India.',
  themeColor: '#001a3a',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Academy India CISO lead generation landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
